export const NEW_JOBS_COUNT = "NEW_JOBS_COUNT";
export const NEW_JOBS_COUNT_SUCCESS = "NEW_JOBS_COUNT_SUCCESS";
export const NEW_JOBS_COUNT_FAILURE = "NEW_JOBS_COUNT_FAILURE";

export const ACTIVE_JOBS_COUNT = "ACTIVE_JOBS_COUNT";
export const ACTIVE_JOBS_COUNT_SUCCESS = "ACTIVE_JOBS_COUNT_SUCCESS";
export const ACTIVE_JOBS_COUNT_FAILURE = "ACTIVE_JOBS_COUNT_FAILURE";

export const INACTIVE_JOBS_COUNT = "INACTIVE_JOBS_COUNT";
export const INACTIVE_JOBS_COUNT_SUCCESS = "INACTIVE_JOBS_COUNT_SUCCESS";
export const INACTIVE_JOBS_COUNT_FAILURE = "INACTIVE_JOBS_COUNT_FAILURE";

export const CLOSED_JOBS_COUNT = "CLOSED_JOBS_COUNT";
export const CLOSED_JOBS_COUNT_SUCCESS = "CLOSED_JOBS_COUNT_SUCCESS";
export const CLOSED_JOBS_COUNT_FAILURE = "CLOSED_JOBS_COUNT_FAILURE";

export const ASSIGNED_JOBS_COUNT = "ASSIGNED_JOBS_COUNT";
export const ASSIGNED_JOBS_COUNT_SUCCESS = "ASSIGNED_JOBS_COUNT_SUCCESS";
export const ASSIGNED_JOBS_COUNT_FAILURE = "ASSIGNED_JOBS_COUNT_FAILURE";

export const FOD_COUNT = "FOD_COUNT";
export const FOD_COUNT_SUCCESS = "FOD_COUNT_SUCCESS";
export const FOD_COUNT_FAILURE = "FOD_COUNT_FAILURE";

export const ALL_JOBS_COUNT = "ALL_JOBS_COUNT";
export const ALL_JOBS_COUNT_SUCCESS = "ALL_JOBS_COUNT_SUCCESS";
export const ALL_JOBS_COUNT_FAILURE = "ALL_JOBS_COUNT_FAILURE";
